import { useEffect, useRef, useState } from "react";
import { calculatePopupPosition } from "./calculatePopupPosition";

export const DEFAULT_ANCHORED_POPUP_WIDTH = 315;

type UseAnchoredPopupPositionParams = {
	popupWidth?: number;
	topOffset?: number;
	viewportGutter?: number;
};

export const useAnchoredPopupPosition = ({
	popupWidth = DEFAULT_ANCHORED_POPUP_WIDTH,
	topOffset,
	viewportGutter,
}: UseAnchoredPopupPositionParams) => {
	const [popupStyle, setPopupStyle] = useState({});
	const wrapperRef = useRef<HTMLDivElement | null>(null);

	const updatePosition = () => {
		if (!wrapperRef.current) return;

		setPopupStyle(
			calculatePopupPosition({
				anchorRect: wrapperRef.current.getBoundingClientRect(),
				popupWidth,
				topOffset,
				viewportGutter,
			}),
		);
	};

	useEffect(() => {
		updatePosition();
		window.addEventListener("resize", updatePosition);

		return () => window.removeEventListener("resize", updatePosition);
	}, [popupWidth, topOffset, viewportGutter]);

	return {
		popupStyle,
		wrapperRef,
		updatePosition,
	};
};
